import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-service-item"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('swiper', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "auto": "",
      "loop": "",
      "height": "130px",
      "dots-position": "center",
      "dots-class": "dots-class",
      "aspect-ratio": 300 / 800,
      "interval": 5000
    }
  }, [_vm.bannerList.length === 0 ? _c('swiper-item', {
    staticClass: "banner-list"
  }, [_vm.hasMounted ? _c('img', {
    attrs: {
      "src": require("@/assets/img/banner.png"),
      "width": "100%",
      "height": "100%"
    }
  }) : _vm._e()]) : _vm._l(_vm.bannerList, function (item, index) {
    return _c('swiper-item', {
      key: index,
      staticClass: "banner-list"
    }, [_c('img', {
      attrs: {
        "src": item.img_url,
        "width": "100%",
        "height": "100%"
      }
    })]);
  })], 2)], 1), _c('div', {
    staticClass: "home-list"
  }, [_c('div', {
    staticClass: "smy__header-title"
  }, [_c('div', {
    staticClass: "smy__title"
  }, [_vm._v(i18n.tc("69"))])]), _c('div', {
    staticClass: "service-body"
  }, [_c('div', {
    staticClass: "service-msg"
  }, [_c('div', {
    staticClass: "service-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.detail.logo || '/spa_static/editIcon/server-4.png',
      "width": "100%",
      "height": "100%"
    }
  })]), _c('div', {
    staticClass: "service-text font-size-h2-large"
  }, [_c('p', {
    staticClass: "primary-text"
  }, [_vm._v(_vm._s(_vm.detail.name))]), !_vm.codeMap['40019'] ? _c('p', {
    staticClass: "service-price"
  }, [_c('font', {
    staticClass: "label-text"
  }, [_vm._v(i18n.tc("422"))]), _c('font', {
    staticClass: "primary-text"
  }, [_vm._v("￥" + _vm._s(_vm.detail.offer_price))])], 1) : _vm._e()])]), _c('div', {
    staticClass: "service-desc label-text font-size-h3-large"
  }, [_c('p', [_vm._v(i18n.tc("423"))]), _vm.detail.descri ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.descri)
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.goAppoint.apply(null, arguments);
      }
    }
  }, [_vm._v(i18n.tc("424"))])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };